import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { ContentPageModel } from "@solveindustrial/Services/ContentSearchService";
import { ContentFilters, ContentSearchState } from "@solveindustrial/Store/State/ContentSearch/ContentSearchState";
import { Draft } from "immer";

export const initialContentSearchState: ContentSearchState = {
    isLoading: false,
    searchResults: [],
    pagination: {
        currentPage: 1,
        page: 1,
        pageSize: 20,
        defaultPageSize: 20,
        totalItemCount: 0,
        numberOfPages: 0,
        pageSizeOptions: [],
        sortOptions: [],
        sortType: "",
        nextPageUri: "",
        prevPageUri: "",
        nextPageToken: "",
    },
    contentFilters: {},
    error: undefined,
};

export const contentSearchReducer = createTypedReducer(initialContentSearchState, {
    "ContentSearch/SetLoading": (draft: Draft<ContentSearchState>, { isLoading }: { isLoading: boolean }) => ({
        ...draft,
        isLoading,
    }),

    "ContentSearch/SetContentFilters": (
        draft: Draft<ContentSearchState>,
        { contentFilters }: { contentFilters: ContentFilters },
    ) => ({
        ...draft,
        contentFilters,
    }),

    "ContentSearch/SetSearchResults": (
        draft: Draft<ContentSearchState>,
        {
            searchResults,
            pagination,
        }: {
            searchResults: ContentPageModel[];
            pagination: PaginationModel;
        },
    ) => ({ ...draft, searchResults, pagination, isLoading: false, error: undefined }),

    "ContentSearch/SetError": (draft: Draft<ContentSearchState>, { error }: { error: string }) => ({
        ...draft,
        error,
        isLoading: false,
    }),

    "ContentSearch/Reset": () => initialContentSearchState,
});
